export default __webpack_public_path__ + "static/media/03.375acd75.jpg";